module.exports = __webpack_public_path__ + "967f72a2705872d245977f368f417e7f.svg";